import React, { Component } from 'react';
import PropTypes from 'prop-types';

class CollapsibleText extends Component {
  static propTypes = {
    className: PropTypes.string
  };

  static defaultProps = {
    className: ''
  };

  render() {
    return (
      <div
        className={this.props.className}
        // style={{ height: `${this.props.maxHeight}px` }}
        ref={node => {
          this.textNode = node;
        }}
        dangerouslySetInnerHTML={{
          __html: this.props.text
        }}
      />
    );
  }
}

export default CollapsibleText;
